import * as React from 'react';
import {Route, Switch, useRouteMatch} from "react-router";
import Login from "../../Components/Login";
import Logout from "../../Components/Logout";
import ActionSelection from "../../Components/ActionSelection";
import ActivationRequired from "../../Components/ActivationRequired";
import LoginCode from "../../Components/LoginCode";


const AuthContainer: React.FunctionComponent = () => {
    let {path} = useRouteMatch();
    return (<React.Fragment>
        <Switch>
            <Route exact={true} path={path + "/login"} component={Login}/>
            <Route exact={true} path={path + "/logout"} component={Logout}/>
            <Route exact={true} path={path + "/activation-required"}>
                <ActivationRequired/>
            </Route>
            <Route exact={true} path={path + "/action-items"}>
                <ActionSelection/>
            </Route>
            <Route exact={true} path={path + "/login-code"}>
                <LoginCode/>
            </Route>
        </Switch>
    </React.Fragment>);
};

export default AuthContainer;